import Base from './Base';
import Keyword from '../models/Keyword';

export default class Keywords extends Base {
    get models() {
        const collection = this.data.map(item => new Keyword(item));
        collection.collection = this;

        return collection;
    }
}
